import { Bar } from 'vue-chartjs'

export default {
    name: 'bar-chart',
    extends: Bar,
    watch: {
        chartdata: function (newValue, oldValue) {
            this.$data._chart.destroy()
            this.renderChart(this.chartdata, this.options)
        }
    },
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        }
    },
    mounted () {
        this.renderChart(this.chartdata, this.options)
    }
}
